"use client";

import { X } from "lucide-react";
import { cn } from "~/lib/utils";
import { SparkleGlyph } from "./shared";

// // // //

/**
 * DockLauncher
 *
 * Closed: a gradient "Ask AI" pill with the sparkle mark (design story
 * `trigger`, idle). Open: a matching circular orb with a close glyph and a
 * glossy highlight.
 */
export function DockLauncher(props: { isOpen: boolean; onClick: () => void }) {
    const { isOpen, onClick } = props;

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={isOpen ? "Close chats" : "Ask AI Diligence"}
            aria-expanded={isOpen}
            className={cn(
                "group relative z-10 shrink-0 overflow-hidden bg-linear-to-br from-primary to-primary-dark text-primary-foreground shadow-xl shadow-primary/40 ring-1 ring-inset ring-white/15",
                "transition duration-300 ease-out",
                "hover:shadow-2xl hover:shadow-primary/50",
                "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:outline-none",
                "active:scale-95",
                isOpen
                    ? "flex size-13 items-center justify-center rounded-full"
                    : "flex h-13 items-center gap-2 rounded-full px-4.5 text-sm font-semibold",
            )}
        >
            {isOpen ? (
                <>
                    <span
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-0 rounded-full bg-[radial-gradient(circle_at_30%_22%,rgba(255,255,255,0.42),transparent_55%)]"
                    />
                    <X className="relative size-5" />
                </>
            ) : (
                <>
                    <SparkleGlyph className="size-5 shrink-0" />
                    <span>Ask AI Diligence</span>
                </>
            )}
        </button>
    );
}
